<div class="dtf-accountdetails">
<mat-dialog-content>
  @if(this.addressdialog ==='one'){
    @if(this.language ==='en-US' || this.language ==='en-US'){
      <h2><b>Change of Address</b></h2>
      <p>You have successfully submitted this request. Please allow 1 to 2 business days for this request to process depending on current volume.</p>
    }
    @if(this.language ==='fr-CA'){
      <h2><b>Changement d'adresse</b></h2>
      <p>Succès, votre demande de mise à jour d'adresse a été soumise.</p>
     }
  }
  @if(this.addressdialog ==='error'){
    @if(this.language ==='en-US' || this.language ==='en-US'){
      <h2><b>Error</b></h2>
     }
    @if(this.language ==='fr-CA'){
      <h2><b>Erreur</b></h2>
     }
     <p><b>{{errorMessage}}.</b></p>
  }
    
</mat-dialog-content>  
<mat-dialog-actions>
  @if(this.addressdialog ==='one'){
    <button mat-button (click)="dashboardRedirect($event)" mat-dialog-close>Continue</button>
    }
  
    @if(this.addressdialog ==='error'){
    <button mat-button (click)="dashboardRedirect($event)" mat-dialog-close>Cancel</button>
    <button mat-button mat-dialog-close>Continue</button>
    }
</mat-dialog-actions>
</div>
